import React, { useState, useEffect, useCallback } from "react";
import { Container, HeaderRow, List, ListItem, ListItemLabel, ListItemActions } from "./ChatsList.styled";
import { Typography, ButtonMenu } from "@ann/web-components";

const CHAT_LIST_URL = `${process.env.PUBLIC_URL || ""}/chat-list.json`;

const MAX_CHARS_DEFAULT = 29;
const MAX_CHARS_HOVER = 24;

const ChatsList = ({ selectedConversationId, onSelectConversation }) => {
  const [chatList, setChatList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [hoveredConversationId, setHoveredConversationId] = useState(null);

  useEffect(() => {
    const loadChatList = async () => {
      try {
        const res = await fetch(CHAT_LIST_URL);
        const data = await res.json();
        setChatList(Array.isArray(data) ? data : []);
      } catch {
        setChatList([]);
      } finally {
        setLoading(false);
      }
    };
    loadChatList();
  }, []);

  const handleItemClick = useCallback(
    (conversationUuid) => {
      onSelectConversation?.(conversationUuid);
    },
    [onSelectConversation]
  );

  return (
    <Container>
      <HeaderRow>
        <Typography category="subtitle" size="small" weight="bold">
          Chats
        </Typography>
      </HeaderRow>

      <List>
        {loading
          ? null
          : chatList.map((chat) => (
              <ListItem
                key={chat.conversation_uuid}
                $isSelected={selectedConversationId === chat.conversation_uuid}
                onClick={() => handleItemClick(chat.conversation_uuid)}
                onMouseEnter={() => setHoveredConversationId(chat.conversation_uuid)}
                onMouseLeave={() => setHoveredConversationId(null)}
              >
                <ListItemLabel>
                  <Typography
                    category="body"
                    size="medium"
                    weight="regular"
                    color="body"
                    maxCharacters={
                      hoveredConversationId === chat.conversation_uuid
                        ? MAX_CHARS_HOVER
                        : MAX_CHARS_DEFAULT
                    }
                  >
                    {chat.title}
                  </Typography>
                </ListItemLabel>
                <ListItemActions onClick={(e) => e.stopPropagation()}>
                  <ButtonMenu
                    alignMenu="left"
                    customIcon="dotsMenu"
                    iconPosition="right"
                    label=""
                    menuPosition="top"
                    onChange={() => {}}
                    size="medium"
                    type="tertiary"
                    usePortal
                    width="auto"
                    disableEffects={true}
                    className="chat-actions"
                  >
                    <ButtonMenu.Menu icon={true}>
                      <ButtonMenu.Item label="Rename" value="rename" icon="edit">
                        Rename
                      </ButtonMenu.Item>
                      <ButtonMenu.Item label="Pin chat" value="pin_chat" icon="keep">
                        Pin chat
                      </ButtonMenu.Item>
                      <ButtonMenu.Item label="Delete" value="delete" icon="delete">
                        Delete
                      </ButtonMenu.Item>
                    </ButtonMenu.Menu>
                  </ButtonMenu>
                </ListItemActions>
              </ListItem>
            ))}
      </List>
    </Container>
  );
};

export default ChatsList;
